import * as React from 'react';

export const Alert = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.894 20.986L12.884 1.909a.827.827 0 00-.71-.409h-.327c-.29 0-.56.156-.709.409L.106 20.986a.883.883 0 000 .84l.153.254a.795.795 0 00.71.42h22.063a.795.795 0 00.709-.42l.153-.254a.883.883 0 000-.84zm-10.803-3.46a.55.55 0 01-.545.553h-1.092a.55.55 0 01-.545-.553v-1.105a.55.55 0 01.545-.553h1.092a.55.55 0 01.545.553v1.105zm-.513-3.868a.274.274 0 00.273-.243l.437-3.56a.557.557 0 00-.135-.434.542.542 0 00-.411-.184h-1.484a.542.542 0 00-.41.184.558.558 0 00-.136.435l.437 3.559c.017.14.134.244.273.243h1.156z"
    ></path>
  </svg>
);
